import { z } from "zod";

import { fileSchema } from "../../components/form/RHF-fields/form-file-input";

export const sentryErrorFeedbackSchema = z.object({
  file: fileSchema.nullable().optional(),
  message: z.string().trim().min(1),
});

export type SentryErrorFeedbackValues = z.infer<
  typeof sentryErrorFeedbackSchema
>;
